import { useCallback, useState } from 'react';

export function useVideoActions(videoRef, addFrame, addClip, setIsPlaying) {
  const [isRecordingClip, setIsRecordingClip] = useState(false);
  const [clipStartTime, setClipStartTime] = useState(0);

  const captureFrame = useCallback(() => {
    if (videoRef.current) {
      const video = videoRef.current;
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      return canvas.toDataURL('image/png');
    }
    return null;
  }, [videoRef]);

  const handleAddFrameToTimeline = useCallback(() => {
    if (videoRef.current) {
      console.log("Attempting to add frame at time:", videoRef.current.currentTime);
      const frameData = captureFrame();
      if (frameData) {
        addFrame(videoRef.current.currentTime, frameData);
        console.log("Frame added successfully.");
      } else {
        console.error("Failed to capture frame.");
      }
    } else {
      console.error("videoRef.current is null when trying to add frame.");
    }
  }, [addFrame, videoRef, captureFrame]);

  const handleAddClipToTimeline = useCallback(() => {
    if (!videoRef.current) {
      console.error("videoRef.current is null when trying to add clip.");
      return;
    }

    if (!isRecordingClip) {
      console.log("Starting clip recording at:", videoRef.current.currentTime);
      setClipStartTime(videoRef.current.currentTime);
      setIsRecordingClip(true);
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      console.log("Stopping clip recording at:", videoRef.current.currentTime);
      const clipEndTime = videoRef.current.currentTime;
      videoRef.current.pause();
      setIsPlaying(false);
      const frameData = captureFrame();
      if (frameData) {
        addClip(clipStartTime, clipEndTime, frameData);
        console.log("Clip added successfully.");
      } else {
        console.error("Failed to capture frame for clip.");
      }
      setIsRecordingClip(false);
      setClipStartTime(0);
    }
  }, [addClip, videoRef, captureFrame, isRecordingClip, setIsRecordingClip, clipStartTime, setClipStartTime, setIsPlaying]);

  return { handleAddFrameToTimeline, handleAddClipToTimeline, captureFrame, isRecordingClip };
}